import { capitalize, Typography } from '@mui/material'
import Button from '@mui/material/Button'
import { styled } from '@mui/system'
import PropTypes from 'prop-types'
import React from 'react'
import { useSelector } from 'react-redux'
import { useDefaultComponentTools } from '../../../../hooks/useDefaultComponentTools'
import { selectUserId } from '../../../../store/redusers/user/selectors'

const AssetBtn = styled(Button)(() => ({
	minHeight: '32px',
	textTransform: 'none',
	width: '49%'
}))

const AssetsButton = ({rate, color, action, clickAsset, active}) => {
	const { theme, t, xxlDown } = useDefaultComponentTools()
	const isAuthorized = useSelector(selectUserId)
	const onClickAssetBtn = (e) => {
		e.stopPropagation()
		clickAsset(e, 'type_asset', action)
	}
	return (
		<AssetBtn
			sx={{'&:hover': { '& .assets-number': { color: '#ffff' },
				background: action === 'sell' ? theme.palette.red : theme.palette.green },
			background: active === action ?
				(active === 'buy' ? theme.palette.green : theme.palette.red) :
				theme.palette.second,
			display: 'flex', flexDirection: xxlDown ? 'column' : 'row', p: '6px 2px'}}
			disabled={!isAuthorized} onClick={onClickAssetBtn}
		>
			<Typography className='assets-number'
				sx={{color:  active === action ? '#FFFFFF' : color, mr: 0.188}}
			>
				{t(capitalize(action))}
			</Typography>
			<Typography className='assets-number'
				sx={{color: active === action ? '#FFFFFF' : color}}
			>
				{rate}
			</Typography>
		</AssetBtn>
	)
}

AssetsButton.propTypes = {
	action: PropTypes.string,
	active: PropTypes.string,
	clickAsset: PropTypes.func,
	color: PropTypes.string,
	rate: PropTypes.any
}

AssetsButton.displayName = 'AssetsButtons'

export default AssetsButton
